import * as filter from "./filter";

export function buildODataKendoParams(args) {
    var data = args.data,
        sortExpression = args.sortExpression || "",
        filterExpression = args.filterExpression || "",
        selectExpression = args.selectExpression || "",
        expandExpression = args.expandExpression || "",
        autoCompleteConditional = args.autoCompleteConditional || null,
        dataTextField = args.dataTextField || null;

    if (data.sort && data.sort.length > 0) {
        sortExpression = "";
        $.each(data.sort, function (index, item) {
            if (sortExpression != "") {
                sortExpression += ",";
            }
            sortExpression += item.field + " " + item.dir;
        });
    }

    var filt = filter.empty();

    if (data && data.filter && !args.disableAutoCompleteConditional) {
        if (autoCompleteConditional && data.filter.filters.length > 0) {
            var value = $.trim(data.filter.filters[0].value),
                operator = data.filter.filters[0].operator;
            if (value) {
                $.each(autoCompleteConditional, function (index, conditional) {
                    if (conditional.type) {
                        var filterToApply = filt.kendoFilterMap[conditional.type];
                        filt = filt.add("or", filterToApply, [conditional.value, value]);
                    } else {
                        filt = operator == "contains"
                            ? filt.orContains(conditional.value, value)
                            : filt.orStartsWith(conditional.value, value);
                    }
                });
            } else if (dataTextField) {
                filt = filter.isNotNull(dataTextField);
            }
        } else if (!args.isFunction) {
            filt = filter.createFromKendoFilter(data.filter);
        }
    }

    if (filterExpression) {
        filt = filter.where(filterExpression).and(filt);
    }

    filterExpression = decodeURIComponent(filt.toString());

    return {
        $inlinecount: "allpages",
        $top: data.take,
        $skip: data.skip,
        $pageSize: data.pageSize,
        $orderby: sortExpression || undefined,
        $filter: filterExpression || undefined,
        $expand: expandExpression || undefined,
        $select: selectExpression || undefined
    };
}
